import { render, staticRenderFns } from "./stepSix.vue?vue&type=template&id=60b7151d&"
import script from "./stepSix.vue?vue&type=script&lang=js&"
export * from "./stepSix.vue?vue&type=script&lang=js&"
import style0 from "./stepSix.vue?vue&type=style&index=0&id=60b7151d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports